<template>
    <div :class="`top-bar ${barTheme ? barTheme : ''} wrap vc`" :style="barStyle">
        <div class="bar-left vc">
            <a class="icon-wrap" @click="returnFn">
                <i class="icon icon-return"></i>
            </a>
            <slot name="title"></slot>
        </div>
        <a href="/">
            <h1 class="logo">皇家游享荟</h1>
        </a>
        <div class="bar-right vc">
            <a class="icon icon-chat" href="javascript: void(0)" @click="showLayer"></a>
            <a class="icon icon-tel" href="tel:400-820-7293"></a>
            <a class="icon icon-note" href="javascript: void(0)" @click="showPdf"></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TopBar',
        props: ['barTheme', 'barStyle'],
        data () {
            return {}
        },
        methods: {
            showLayer () {
                window.open('https://rcclchina.udesk.cn/im_client/?web_plugin_id=75221', 'newwindow', 'height=400, width=400')
            },
            showPdf () {
                window.open('/content/rewardprivacy')
            },
            returnFn () {
                if (this.$route.path !== '/recommend/courtesy') {
                    if (window.history.length <= 1) {
                        window.location.href = "/Rccl.UserCenter/CustomerInfo/Info";
                    } else {
                        window.history.back()
                    }
                } else {
                    window.history.back()
                }

            }
        }
    }
</script>

<style lang="less" scoped>
    .top-bar{
        justify-content: space-around;
        -webkit-justify-content: space-around;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        width: 100%;
        height: 1.00rem;
        .bar-left{
            width: 2.50rem;
            height: 100%;
            .icon-wrap{
                display: block;
                width: 0.40rem;
                height: 0.40rem;
            }
            .icon-return{
                width: 0.32rem;
                height: 0.40rem;
                background: url("../../assets/images/return.png") no-repeat;
                background-size: 100% 100%;
            }
            .page-title{
                padding-left: 0.06rem;
                font-size: 0.32rem;
                transform: scale(0.9375);
                -webkit-transform: scale(0.9375);
            }
        }
        .logo{
            font-size: 0.32rem;
            color: #4A90E2;
            // display: block;
            // width: 0.54rem;
            // height: 0.60rem;
            // background: url("../../assets/images/logo.png") no-repeat;
            // background-size: cover;
        }
        .bar-right {
            justify-content: flex-end;
            -webkit-justify-content: flex-end;
            width: 2.4rem;
            height: 100%;
            .icon {
                display: block;
                width: 0.47rem;
                height: 0.47rem;
                margin-left: 0.24rem;
                &.icon-chat{
                    background: url("../../assets/images/icon_chat.png") no-repeat;
                    background-size: 0.47rem 0.47rem;
                }
                &.icon-tel{
                    background: url("../../assets/images/icon_tel.png") no-repeat;
                    background-size: 0.46rem 0.47rem;
                }
                &.icon-note{
                    background: url("../../assets/images/icon_note.png") no-repeat;
                    background-size: 0.47rem 0.47rem;
                }
            }
        }
        &.white{
            .icon-return{
                background: url("../../assets/images/return_white.png") no-repeat;
                background-size: 100% 100%;
            }
            .logo{
                color: white;
                // background: url("../../assets/images/logo_white.png") no-repeat;
                // background-size: 100% 100%;
            }
            .icon {
                &.icon-chat{
                    background: url("../../assets/images/icon_chat_white.png") no-repeat;
                    background-size: 100% 100%;
                }
                &.icon-tel{
                    background: url("../../assets/images/icon_tel_white.png") no-repeat;
                    background-size: 100% 100%;
                }
                &.icon-note{
                    background: url("../../assets/images/icon_note_white.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
        .popup{
            position: fixed;
            left: 120%;
            top: 0;
            width: 100%;
            height: 100vh;
            z-index: 999999;
            background: #fff;
            overflow: auto;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            &.popup-show{
                left: 0;
            }
            .shorexDetail-title{
                padding: 15px 20px;
                background-color: #fff;
                overflow: hidden;
                text-align: center;
                margin-bottom: 10px;
                position: fixed;
                width: 100%;
                z-index: 10;
                p{
                    font-size: 14px;
                    color: #333333;
                    letter-spacing: 1px;
                    text-align: center;
                    margin: 0;
                }
                .shorexDetail-returnButton{
                    width: 30px;
                    position: absolute;
                    top: 15px;
                    left: 20px;
                    text-align: left;
                    img{
                        width: 33%;
                    }
                }
            }
            .ruleDetail{
                margin-top: 60px;
                height: calc(100vh - 60px);
                overflow: scroll;
                padding-bottom: 60px;
                .rule-item{
                    margin-bottom: 10px;
                    padding: 0 20px 12px;
                    font-size: 12px;
                    line-height: 20px;
                    color: #666;
                    letter-spacing: 0;
                    background-color: #fff;
                    .faq-content{
                        margin-bottom: 10px;
                        padding-bottom: 10px;
                        border-bottom: 1px solid #f3eeee;
                        .faq-question{
                            color: #333;
                            font-weight: bold;
                            .visa_right__titlt{
                                width: 90%;
                                display: inline-block;
                                vertical-align: top;
                                margin-top: 0 !important;
                            }
                            .faq-hot{
                                display: inline-block;
                                width: 20px;
                                vertical-align: middle;
                            }
                            .f7-icons{
                                display: inline-block;
                                width: 0.22rem;
                                height: 0.22rem;
                                background: url("../../assets/images/down.png") no-repeat;
                                background-size: 100% 100%;
                                margin-left: 0.2rem;
                                margin-top: 0.1rem;
                                text-indent: -2000px;
                                transform: rotateZ(-90deg);
                                -webkit-transform: rotateZ(-90deg);
                            }
                        }
                        .faq-answer{
                            display: none;
                            padding-top: 10px;
                        }
                        &.active{
                            .faq-question{
                                .f7-icons{
                                    transform: rotateZ(0deg);
                                    -webkit-transform: rotateZ(0deg);
                                }
                            }
                            .faq-answer{
                                display: block;
                            }
                        }
                    }
                    .faq-more{
                        display: block;
                        width: 126px;
                        text-align: center;
                        height: 24px;
                        line-height: 24px;
                        border: 1px solid #4A90E2;
                        border-radius: 25px;
                        color: #4A90E2;
                        font-size: 14px;
                        margin: 20px auto 0;
                    }
                }
            }
        }
    }
</style>
